import { Box, Center, Container, Spinner } from '@chakra-ui/react';
import EventDetailLoaded from 'presentation/components/modules/events/detail/EventDetailLoaded';
import EventDetailSidebar from 'presentation/components/modules/events/detail/EventDetailSidebar';
import AppCard from 'presentation/components/shared/card/AppCard';
import ErrorContainer from 'presentation/components/shared/ErrorContainer';
import EventsPageLayout from 'presentation/layout/modules/events/EventsPageLayout';
import SidebarLayout from 'presentation/layout/shared/SidebarLayout';
import { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router-dom';
import {
  useFetchEventDetailQuery,
} from 'rtkQuery/sharespro/queries/events';

const EventDetailPage: FC = () => {
  const { id } = useParams();

  const parsedId = +(id as string);

  const {
    data: eventDetailData,
    refetch: refetchEventDetail,
    isFetching: isEventDetailFetching,
    error: eventDetailError,
  } = useFetchEventDetailQuery(parsedId);

  let content;
  let sidebar;
  let wrapByCard = true;
  if (isEventDetailFetching) {
    content = <Spinner />;
  } else if (eventDetailData) {
    wrapByCard = false;
    content = <EventDetailLoaded data={eventDetailData} />;
    sidebar = <EventDetailSidebar data={eventDetailData}/>;
  } else if (eventDetailError) {
    content = (
      <ErrorContainer
        error={eventDetailError}
        onRetry={() => {
          refetchEventDetail();
        }}
      />
    );
  } else {
    content = <Spinner />;
  }

  if (wrapByCard) {
    content = (
      <AppCard p="20px">
        <Center>{content}</Center>
      </AppCard>
    );
  }

  if (sidebar) {
    content = (
      <Container display="flex" alignItems="flex-start">
        <SidebarLayout>{sidebar}</SidebarLayout>
        <Box flex="1">{content}</Box>
      </Container>
    );
  } else {
    content = <Container>{content}</Container>;
  }

  return (
    <EventsPageLayout>
      <Helmet>
        {eventDetailData?.name && <title>{eventDetailData.name}</title>}
      </Helmet>
      {content}
    </EventsPageLayout>
  );
};

export default EventDetailPage;
